exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".opacity-50[data-v-d3c0bb78]{opacity:.5!important}.opacity-100[data-v-d3c0bb78]{opacity:1!important}", ""]);

// exports
